import { Component } from '@angular/core';
import { NotificationsListComponent } from '../notifications-list/notifications-list.component';
import { NotificationListService } from 'src/app/core/services/list-services/notification-list.service';
import { NotificationModel } from 'src/app/core/models/push/notification.model';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { NotificationViewModalService } from 'src/app/core/services/modal-services/notification-view-modal.service';
import { BadgeCountService } from 'src/app/core/services/badgecount.service';
import { TableConfigurationModel } from 'src/app/core/models/table/table-configuration.model';
import { ServiceData } from 'src/app/core/models/table/service-data.model';
import { Observable } from 'rxjs';
import { SortByTypeEnum } from 'src/app/core/enums/list-layout/sort-type-enum';
import { EmitSortModel } from 'src/app/core/models/table/emit-sort.model';
import { NotificationExtendedListLayoutConfig } from './notifications-extended-list.config';
import { ListFilterModel } from 'src/app/core/models/table/list-filter.model';
import { TableActionsModel } from 'src/app/core/models/table/table-action.model';
import { ActionIdEnum } from 'src/app/core/enums/list-layout/action-id-enum';
import { ButtonIdEnum } from 'src/app/core/enums/list-layout/button-id-enum';
import Swal from 'sweetalert2';
import { NotificationsSearchModel } from 'src/app/core/models/push/notifications-search.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notifications-extended',
  templateUrl: './notifications-extended.component.html',
  styleUrls: ['./notifications-extended.component.scss'],
  providers: [NotificationListService]
})
export class NotificationsExtendedComponent extends NotificationsListComponent {
  isReadValue: boolean | undefined = undefined;

  tableConfig: TableConfigurationModel = new TableConfigurationModel();

  serviceData: ServiceData = new ServiceData();

  protected override searchPlaceHolderText: string = $localize`:@@:Search for files by name`;

  override listItemsObservable!: Observable<NotificationModel[]>;

  sortBy: any;


  constructor(
    protected notificationViewModalService: NotificationViewModalService,
    protected override notificationListService: NotificationListService,
    protected override badgeCountService: BadgeCountService,
    protected override router: Router,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override openModalService: OpenModalService,
    protected override authMyFileService: AuthMyfileService,
  ) {
    super(notificationListService, badgeCountService, router, toasterNotificationService, myFileApiService, sanitizer, pdfModalService, openModalService, authMyFileService);
  }


  override ngOnInit(): void {

    this.listItemsObservable = this.notificationListService.resultItems$;
    this.total = this.notificationListService.total$;
    this.isLoading = this.notificationListService.loading$;

    var subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.serviceData.loadingValue = true;
      } else {
        this.serviceData.loadingValue = false;
      }
    });
    this.unsubscribe.push(subscr);

    var subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
      this.fullListItems = Object.assign([], this.listItems);
    });
    this.unsubscribe.push(subscr2);

    var subscr3 = this.total.subscribe(result => {
      this.serviceData.totalRecords = this.notificationListService.totalRecords;
      this.serviceData.pageSize = this.notificationListService.pageSize;
      this.serviceData.pageIndex = this.notificationListService.pageIndex;
    });
    this.unsubscribe.push(subscr3);

    var subscr4 = this.badgeCountService.badgeCountUpdated$.subscribe(result => {
      if (result) {
        this.serviceSort(this.notificationListService, this.notificationListService.sortColumnDirective, this.notificationListService.sortDirection);
      }
    });

    this.unsubscribe.push(subscr4);

    this.tableConfig = new NotificationExtendedListLayoutConfig();

  }

  override rowActionSelected(rowAction: TableActionsModel): void {
    switch (rowAction.actionIdSelected) {
      case ActionIdEnum.Delete:
        this.delete(rowAction.model.id);
        break;
      case ActionIdEnum.View:
        this.openNotificationModal(rowAction.model);
        break;
      case ActionIdEnum.Select:
        this.changeReadStatus(rowAction.model.id);
        break;
    }
  }

  override buttonActionSelected(buttonAction: any): void {

    switch (buttonAction.buttonId) {
      case ButtonIdEnum.Enable:
        this.changeReadStatusMultiple('checkAll');
        break;
      case ButtonIdEnum.Delete:
        this.deleteMultipleListItems();
        break;
    }
  }

  override filterSelected(filterSelected: ListFilterModel): void {

    switch (filterSelected.label) {
      case 'SelectStatus':
        this.notificationListService.isRead = filterSelected.selectedOption;
        this.serviceSort(this.notificationListService, this.notificationListService.sortColumnDirective, this.notificationListService.sortDirection)
        break;
      case 'SelectTypes':
        this.notificationListService.type = filterSelected.selectedOption;
        this.serviceSort(this.notificationListService, this.notificationListService.sortColumnDirective, this.notificationListService.sortDirection)
        break;
    }
  }

  openNotificationModal(model: NotificationModel) {
    this.notificationViewModalService.openModal(model, true);
  }

  delete(id: string, waitToReloadList?: boolean) {
    this.myFileApiService.deleteNotifications(id).subscribe((result) => {
      if (waitToReloadList !== true) {
        this.serviceSort(this.notificationListService, this.notificationListService.sortColumnDirective, this.notificationListService.sortDirection);
        this.badgeCountService.getBadgeCount();
        this.submitted = false;
      }
    });
  }

  deleteMultipleListItems() {
    var checkboxes: any = document.getElementsByName('checkAll');
    var result: any;
    var checkedVal: any[] = [];
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        result = checkboxes[i].value;
        checkedVal.push(result);
      }
    }
    if (checkedVal.length > 0) {
      Swal.fire({
        title: $localize`:@@:Delete Notifications`,
        text: $localize`:@@:Are you sure you want to delete these notifications?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(3, 142, 220)',
        cancelButtonColor: 'rgb(243, 78, 78)',
        confirmButtonText: $localize`:@@:Ok`,
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        cancelButtonText: $localize`:@@:Cancel`,
      }).then(result => {
        if (result.isConfirmed) {
          var deleteSearchModel: NotificationsSearchModel = new NotificationsSearchModel();
          deleteSearchModel.pageSize = this.serviceData.pageSize;
          deleteSearchModel.ids = checkedVal;
          var sub = this.myFileApiService.deleteNotificationsList(deleteSearchModel).subscribe((result)=>{
            this.notificationListService.refresh();
            this.updateTopBarCount();
          });
        }
      });
    } else {
      Swal.fire({
        icon: 'warning',
        text: 'Please select a Notification to delete',
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        confirmButtonColor: '#299cdb',
      });
    }
    this.checkedValGet = checkedVal;
  }

  sortByPassedSort(passedSortModel: EmitSortModel) {
    if (passedSortModel.sortSelected == SortByTypeEnum.None) {
      this.serviceSort(this.notificationListService, '', '');
    } else {
      this.serviceSort(this.notificationListService, passedSortModel.fieldName, passedSortModel.sortSelected);
    }
  }

}
